/* 
    Checks for field, object, and function
    Returns true for the following:
    null, 0, {}, [], '', etc.
*/
export const isEmpty = (value: any) => {
    const type = typeof value;
    if ((value !== null && type === 'object') || type === 'function') {
        const props: any = Object.keys(value);
        if (props.length === 0 || props.size === 0) {
            return true;
        }
    }
    return !value;
}